import { NgModule } from '@angular/core';
import { StepOnBehalfListModule } from 'features/professional-step/shared/on-behalf-list/step-on-behalf-list.module';
// Services
import { ProfessionalLogService } from './professional-log.service';
// Main component
import { LogDetailsComponent } from './log-details.component';
import { EntryHeaderComponent } from './modal-content/entry-header/entry-header.component';
import { EntriesComponent } from './modal-content/entries/entries.component';
import { ConfirmInvitationCloseComponent } from './modal-content/confirm-invitation/confirm-invitation-close.component';
import { InvitationComponent } from './modal-content/invitation/invitation.component';
import { CrudEntryComponent } from './modal-content/crud-entry/crud-entry.component';
import { LogSubmitContentComponent } from './modal-content/submit-content/submit-content.component';
import { LogCorrectionsContentComponent } from './modal-content/corrections-content/corrections-content.component';
import { LogSubmitTabsModule } from 'components/modal-windows/step-details/log-details/modal-content/submit-tabs/submit-tabs.module';
import { LogCorrectionsFormModule } from 'components/modal-windows/step-details/log-details/modal-content/corrections-form/corrections-form.module';
import { LogEntriesModule } from 'components/log-entries/log-entries.module';
import { DynamicFormModule } from 'components/dynamic-form/dynamic-form.module';
import { CertemyCommonModule } from 'common/certemy-common.module';
import { DatePickerModule, DisplayHtmlModule } from '@certemy/ui-components';
import { ResetConfirmModule } from 'components/modal-windows/step-details/reset-confirm-content/reset-confirm-content.module';
import { LogService } from 'services/log/log.service';
import { MessageBlockModule } from 'components/message-block/message-block.module';
import { SignatureModule } from 'components/signature/signature.module';

@NgModule({
  imports: [
    CertemyCommonModule,
    StepOnBehalfListModule,
    LogSubmitTabsModule,
    LogCorrectionsFormModule,
    LogEntriesModule,
    DynamicFormModule,
    DatePickerModule,
    DisplayHtmlModule,
    ResetConfirmModule,
    MessageBlockModule,
    SignatureModule,
  ],
  declarations: [
    LogDetailsComponent,
    LogSubmitContentComponent,
    LogCorrectionsContentComponent,
    EntryHeaderComponent,
    EntriesComponent,
    InvitationComponent,
    ConfirmInvitationCloseComponent,
    CrudEntryComponent,
  ],
  exports: [
    LogDetailsComponent,
    LogSubmitContentComponent,
    LogCorrectionsContentComponent,
    EntryHeaderComponent,
    EntriesComponent,
    InvitationComponent,
    ConfirmInvitationCloseComponent,
    CrudEntryComponent,
  ],
  providers: [ProfessionalLogService, LogService],
})
export class ProfessionalLogModule {}
